// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./lib/analytics"
import "./lib/zone"
import "./lib/quiet_return"
import "./lib/open_to"
import { watchCrashes } from "./lib/crash"
import { startEmbed } from "./lib/embed"
import { startKeepPlace } from "./lib/keep_place"

watchCrashes()
startEmbed()
startKeepPlace({ turbo: true })
